export interface QuizQuestion {
  id: string;
}

export type QuizSetId = "warmup" | "challenge";

const baseQuestions: QuizQuestion[] = [
  { id: "q1" },
  { id: "q2" },
  { id: "q3" },
  { id: "q4" },
  { id: "q5" },
];

export const quizQuestionSets: Record<QuizSetId, QuizQuestion[]> = {
  warmup: baseQuestions,
  challenge: baseQuestions,
};

export const defaultQuizSet: QuizSetId = "warmup";
